<script lang="ts" setup>
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useTheme } from 'vuetify'
import { Theme } from '@/constants'
import { useThemeUno } from '@/composables/useTheme'

const theme = useTheme()
const themeUno = useThemeUno()
const { t } = useI18n({ useScope: 'global' })
const menu = ref(false)

const menuItems = computed(() => [
  { label: t('theme.light'), icon: 'mdi-white-balance-sunny', value: Theme.Light },
  { label: t('theme.dark'), icon: 'mdi-moon-waning-crescent', value: Theme.Dark },
])

const currentTheme = computed(() => {
  const currentItem = menuItems.value.find(item => item.value === theme.global.name.value)
  return currentItem || menuItems.value[2]
})

function changeTheme(newTheme: string) {
  themeUno.setTheme(newTheme)
  theme.global.name.value = newTheme
  menu.value = false
}
onMounted(() => {
  theme.global.name.value = themeUno.theme.value
})
</script>

<template>
  <v-menu v-model="menu" :close-on-content-click="false">
    <template #activator="{ props }">
      <v-btn
        color="white"
        v-bind="props"
      >
        <v-icon :icon="currentTheme.icon" class="mr-2" />
        {{ currentTheme.label }}
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(item, index) in menuItems"
        :key="index"
        min-height="40"
        @click="changeTheme(item.value)"
      >
        <template #prepend>
          <v-icon :icon="item.icon" />
        </template>
        <v-list-item-title>{{ item.label }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
